import axios from 'axios';
import https from 'https';
import history from '../history';
import { includes } from 'lodash';

import { getItem } from './localStorageService';

const LOCAL_URL = process.env.REACT_APP_API_URL || `http://localhost:1337`;
// console.log('process.env', process.env);
export const request = {
  init() {
    const token = getItem('token');
    const request = axios.create({
      httpsAgent: new https.Agent({ keepAlive: true }),
      baseURL: LOCAL_URL,
      headers: {
        authorization: `bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    this.attachInterceptor(request);
    return request;
  },

  attachInterceptor(request) {
    request.interceptors.response.use(
      response => {
        // Do something with response data
        return response.data;
      },
      error => {
        // Do something with response error
        const status = error.response.status;
        const handledErrors = [404, 403];
        if (includes(handledErrors, status)) {
          history.push(`/${status}`);
        }
        return Promise.reject(error);
      }
    );
  },

  get() {
    return this.init().get.apply(null, arguments);
  },

  post() {
    return this.init().post.apply(null, arguments);
  },

  delete() {
    return this.init().delete.apply(null, arguments);
  },

  put() {
    return this.init().put.apply(null, arguments);
  }
};



// WEBPACK FOOTER //
// ./src/utils/request.js